export const convertDaysToWeeksAndDaysString = (days: number): string => {
  if (days < 7) return `${days} days`;
  else {
    const fullWeeks = Math.floor(days / 7);
    const leftOverDays = days - fullWeeks * 7;
    if (!leftOverDays) return `${fullWeeks} weeks`;
    return `${fullWeeks} weeks and ${leftOverDays} days`;
  }
};
